exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#videoRegisterModal .v--modal-box.v--modal{min-height:470px!important;min-width:750px!important}#videoRegisterModal .modal__content{height:calc(100% - 60px)!important}#videoRegisterModal .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9716e200","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/video/modals/VideoRegister.vue
// module id = 2022
// module chunks = 0